const NotFound404 = () => {
  window.location.href =
    process.env.NODE_ENV === 'development'
      ? 'https://www.okcoin.jp/404'
      : '/404';
  return null;
};

export default NotFound404;
